const defaultOptions = {
  e: 'improve',
  w: '600',
  h: '410',
  c: 'fill',
  f: 'auto',
  g: 'auto',
};

export const getCloudinaryTransformationsAsUrl = (
  options: Partial<typeof defaultOptions> = {}
) => {
  return Object.entries({
    ...defaultOptions,
    ...options,
  })
    .filter(([key, value]) => value !== undefined)
    .map(([key, value]) => `${key}_${value}`)
    .join(',');
};

export const getCloudinaryImageUrl = (
  publicID: string,
  options: Partial<typeof defaultOptions> = {}
) => {
  return `https://res.cloudinary.com/dfeukorpg/image/upload/${getCloudinaryTransformationsAsUrl(options)}/${publicID}`;
};

export class CloudinaryUrl {
  originalUrl: string;
  url: string;
  constructor(url: string, originalUrl?: string) {
    this.originalUrl = originalUrl || url.toString();
    this.url = url.toString();
  }

  withOptions(options: Partial<typeof defaultOptions> = {}) {
    if (!this.originalUrl) {
      throw new Error('Original URL is not set');
    }
    return new CloudinaryUrl(
      this.originalUrl.replace(
        'upload/v1/',
        `upload/${getCloudinaryTransformationsAsUrl(options)}/`
      ),
      this.originalUrl
    );
  }
  includes(str: string) {
    return this.url.includes(str);
  }
  toString() {
    return this.url;
  }
}
export const replaceCloudinaryImageUrl = (
  url: string | CloudinaryUrl,
  options: Partial<typeof defaultOptions> = {}
) => {
  if (url instanceof CloudinaryUrl) {
    return url.withOptions(options);
  }

  if (!url || !url.toString().includes('https://res.cloudinary.com')) {
    return url;
  }

  return new CloudinaryUrl(url).withOptions(options);
};
